export const validatePassword = (password) => {
  let errorMessage;
  if (!password) errorMessage = 'fieldIsRequired';
  if (password && !(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9~_+^#$@!%*?&]+){6,16}$/.test(password))) errorMessage = 'passwordMustContainBothLettersAndDigits';
  return errorMessage;
};